export default {"src":"https://fishbrain.com/_next/static/media/waxing_gibbous.c686558f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};